import { useState, useEffect } from 'react';
import { featureFlagClient } from '@trello/feature-flag-client';
import { workspaceNavigationEnabled } from './workspaceNavigationEnabled';
import { memberId } from '@trello/session-cookie';

const flagEnabled = featureFlagClient.get('teamplates.web.left-nav-bar', false);

export const useWorkspaceNavigationEnabled = () => {
  const [isFeatureFlagEnabled, setFeatureFlagEnabled] = useState<boolean>(
    flagEnabled,
  );

  const isWorkspaceNavigationEnabled = !!memberId && isFeatureFlagEnabled;

  useEffect(() => {
    const handleFlagChange = (newValue: boolean) => {
      if (isFeatureFlagEnabled === true && newValue === false) {
        setFeatureFlagEnabled(false);
        window.location.reload();
      }
    };

    featureFlagClient.on(
      'teamplates.web.left-nav-bar',
      false,
      handleFlagChange,
    );
    return () =>
      featureFlagClient.off('teamplates.web.left-nav-bar', handleFlagChange);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); //we only want this to fire on mount

  useEffect(() => {
    workspaceNavigationEnabled.setValue(isWorkspaceNavigationEnabled);
  }, [isWorkspaceNavigationEnabled]);

  return isWorkspaceNavigationEnabled;
};
